
      import OnlineOrder from './online-order.vue'
      import type { App, Plugin } from 'vue'

      export const OnlineOrderPlugin: Plugin = {
        install(app: App) {
          app.component('OnlineOrder', OnlineOrder)
        },
      }
      export { OnlineOrder }
      